import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-ink" data-id="element-56" data-mp="c4fw0l6gszqt">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="84e433qj7koq">
        <p className="inline-block rounded bg-forge px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-58" data-mp="m46oyifdn6os">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-paper/80" data-id="element-59" data-mp="h412dgnysadk">
          Podés seguir guardando videos sobre herrería, soldadura, estructuras
          y muebles industriales sin saber qué deberías aprender primero. O
          podés comenzar hoy a desarrollar una habilidad práctica siguiendo una
          ruta organizada desde cero.
        </p>
        <h2 id="cierre" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-60" data-mp="zxy1lzoen6oq">
          No necesitás ser experto en herrería para empezar.{' '}
          <span className="text-forge" data-id="element-61" data-mp="2h3ztka3cgkpw">Necesitás dar el primer paso.</span>
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-gold bg-white p-3 text-ink" data-id="element-62" data-mp="2m218citqlxvk">
          <p className="text-sm font-black uppercase leading-tight text-forge" data-id="element-63" data-mp="2r3ibym3lvyfu">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-anton text-2xl uppercase tracking-wide" data-id="element-64" data-mp="2v1fzzlln4ehn">
            6 Tomos + 5 Bonos
          </p>
          <p className="text-xs text-steel sm:text-sm" data-id="element-65" data-mp="34tby2wnq84lv">
            Valor de los bonos:{' '}
            <span className="font-bold text-forge line-through" data-id="element-66" data-mp="39sf5uov3coxj">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="mt-1 font-anton text-5xl leading-none tracking-tight text-forge sm:text-6xl" data-id="element-67" data-mp="3es1gqrng5t36">
            <span className="text-3xl text-ink sm:text-4xl" data-id="element-68" data-mp="3isbpgc2mixlq">Hoy:</span>{' '}
            {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-69" data-mp="1jpempl7q5kwq">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-steel" data-id="element-70" data-mp="1er3bb61s72ce">
            <span className="flex items-center gap-1" data-id="element-71" data-mp="1npyk8pw7mqje">
              <ZapIcon size={12} className="text-forge" data-id="element-72" data-mp="1nodo4vu8yzjf" />
              Acceso Inmediato
            </span>
            <span className="text-steel/50" data-id="element-73" data-mp="22d9vsrse6aji">•</span>
            <span data-id="element-74" data-mp="1xg9lu5sf8nn4">Entrega Digital</span>
            <span className="text-steel/50" data-id="element-75" data-mp="1xf8ae07htz4v">•</span>
            <span className="flex items-center gap-1" data-id="element-76" data-mp="2bf9ahdfxp2ja">
              <ShieldCheckIcon size={12} className="text-forge" data-id="element-77" data-mp="2beq48tznc2l3" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}